// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"726":"733bea20","853":"2f5e3680","886":"a54f9b02"}[chunkId] + ".css";
};